import PropTypes from "prop-types";
import { Toolbar } from "./toolbar.styles.es.js";
const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  inline: PropTypes.bool,
  justify: PropTypes.oneOf(["end", "space-between"])
};
const defaultProps = {
  inline: false,
  justify: "space-between"
};
Toolbar.propTypes = propTypes;
Toolbar.defaultProps = defaultProps;
export {
  Toolbar
};
